import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';

const getFormattedAmount = (amount, currency, nights) => {
  /*if (!amount) {
    return null;
  }*/
  // Comentamos el código anterior para permitir mostrar cantidades
  // en cero formateadas
  const isAmounts = typeof amount === 'object' && amount !== null;
  const currentAmount = (isAmounts && currency) ? amount[currency.code].amount : amount;
  const setAmount = nights ? currentAmount / nights : currentAmount;
  return formatCurrency(setAmount, currency);
};

const getSubindex = (variant, context) => {
  switch (variant) {
    case 'night':
      return context.t('per night');
    case 'total':
      return context.t('total price');
    default:
      return null;
  }
};

const PriceInline = ({
  className, variant, amount, currency, nights,
}, context) => {
  const sufix = getSubindex(variant, context);
  const showAmount = getFormattedAmount(amount, currency, nights);
  if (!showAmount) {
    return null;
  }
  return (
    <div className={`font-bold uppercase whitespace-nowrap leading-none ${className || ''}`}>
        {/* {renderRoomDiscount(amount, currency)} */}
        {showAmount}
        {sufix && <span className="text-scale-50 ml-1 capitalize" >{sufix} </span>}
    </div>
  );
};
PriceInline.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PriceInline;
